<template lang="pug">
.card.mt-2
  .card-header
    .card-title.h6.text-primary Situações
    small.card-subtitle.text-gray Selecione as situações disponíveis para o fiscal encerrar o serviço
  .card-body
    .text-center(v-if="list.length === 0")
      spinner(:loading="true")
    .text-primary Selecionadas
    table.table.table-hover.table-xs
      thead
        tr
          th Descrição
          th(style="width: 100px") Pontuação
          th.text-right(style="width: 30px")
      tbody
        tr(v-for="item in value")
          td {{ item.descricao }}
          td
            money.form-input-sm(style="width: 90px", v-model="item.pontuacao")
          td.py-1.c-hand(@click="removeItem(item)")
            button.btn.btn-sm.btn-error
              i.icon.icon-delete
    .text-primary.mt-2.pt-2 Todas disponíves
    table.table.table-hover.table-xs
      tbody
        tr(v-for="item in disponiveis")
          td {{ item.descricao }}
          td.py-1.text-right.c-hand(@click="addItem(item)")
            button.btn.btn-sm.btn-primary
              i.icon.icon-plus
</template>

<script>
export default {
  vuex: {
    comentarioSituacoes: {
      state: ["list"],
      actions: ["fetchList"],
    },
  },
  props: {
    value: { type: Array, default: () => [] },
  },

  created() {
    if (this.list.length === 0) {
      this.fetchList()
    }
  },

  methods: {
    isActive(item) {
      return this.value.findIndex((p) => p.id === item.id) > -1
    },

    addItem(item) {
      this.$emit("input", [...this.value, { ...item, pontuacao: 0 }])
    },

    removeItem(item) {
      this.$emit(
        "input",
        this.value.filter((p) => p.id !== item.id),
      )
    },
  },
  computed: {
    disponiveis() {
      return this.list.filter((item) => !this.isActive(item))
    },
  },
}
</script>
